import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
  links: { label: string; href: string }[];
  /** Real routes (e.g. /cx) rendered between the anchor links and Blog. */
  routeLinks?: { label: string; to: string }[];
  onNavigate: (e: React.MouseEvent<HTMLAnchorElement>, href: string) => void;
  language: 'en' | 'ro';
  setLanguage: (lang: 'en' | 'ro') => void;
  isHomePage?: boolean;
}

const MobileMenu = ({ open, onClose, links, routeLinks = [], onNavigate, language, setLanguage, isHomePage = true }: MobileMenuProps) => {
  const navigate = useNavigate();

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    onNavigate(e, href);
    onClose();
  };

  return (
    <div className={`mob-menu${open ? ' open' : ''}`}>
      <button className="mob-close" onClick={onClose}>
        <X size={20} />
      </button>
      {!isHomePage && (
        <a href="/" onClick={(e) => { e.preventDefault(); onClose(); navigate('/'); }} style={{ fontWeight: 700 }}>
          ← Home
        </a>
      )}
      {links.map((link) => (
        <a key={link.href} href={isHomePage ? link.href : `/${link.href}`} onClick={(e) => handleLinkClick(e, link.href)}>
          {link.label}
        </a>
      ))}
      {routeLinks.map((link) => (
        <a key={link.to} href={link.to} onClick={(e) => { e.preventDefault(); onClose(); navigate(link.to); }}>
          {link.label}
        </a>
      ))}
      <a href="/blog" onClick={(e) => { e.preventDefault(); onClose(); navigate('/blog'); }} style={{ color: 'var(--amber)', fontWeight: 700 }}>
        Blog
      </a>
      <div className="mob-lang">
        <button className={language === 'en' ? 'active' : ''} onClick={() => setLanguage('en')}>
          <span className="mob-flag">🇬🇧</span> English
        </button>
        <button className={language === 'ro' ? 'active' : ''} onClick={() => setLanguage('ro')}>
          <span className="mob-flag">🇷🇴</span> Română
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;
